var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 19,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  fillRule: "evenodd",
  d: "M0 2.928A2.25 2.25 0 0 1 2.25.678h19.5A2.25 2.25 0 0 1 24 2.928v13.5a2.25 2.25 0 0 1-2.25 2.25H2.25A2.25 2.25 0 0 1 0 16.429zm2.94-.75L12 9.822l9.06-7.644zm-1.44.747v13.503c0 .415.336.75.75.75h19.5a.75.75 0 0 0 .75-.75V2.925l-9.533 8.044a1.5 1.5 0 0 1-1.934 0zM3 14.178h6.75v1.5H3zm3.75-3H3v1.5h3.75z",
  clipRule: "evenodd"
})));
export default SvgEmail;